<template>
  <main class="employee-add">
    <div class="employee-add__body" ref="body">
      <h1>Новый сотрудник</h1>
      <form
        autocomplete="off"
        class="employee-add__form"
        v-on:submit.prevent="onSubmit"
      >
        <div class="employee-add__form__row">
          <label
            class="employee-add__form__group"
            v-bind:class="{ field_error: surnameInputErrors.length > 0 }"
          >
            <span class="employee-add__form__label">Фамилия</span>
            <input
              class="employee-add__form__input"
              placeholder=""
              type="text"
              v-model="surname"
              v-letter-capital />
            <p
              class="employee-add__form__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in surnameInputErrors"
            >{{ text }}</p>
          </label>
          <label
            class="employee-add__form__group"
            v-bind:class="{ field_error: nameInputErrors.length > 0 }"
          >
            <span class="employee-add__form__label">Имя</span>
            <input
              class="employee-add__form__input"
              placeholder=""
              type="text"
              v-model="name"
              v-letter-capital />
            <p
              class="employee-add__form__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in nameInputErrors"
            >{{ text }}</p>
          </label>
          <label
            class="employee-add__form__group"
            v-bind:class="{ field_error: patronymicInputErrors.length > 0 }"
          >
            <span class="employee-add__form__label">Отчество</span>
            <input
              class="employee-add__form__input"
              placeholder=""
              type="text"
              v-model="patronymic"
              v-letter-capital />
            <p
              class="employee-add__form__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in patronymicInputErrors"
            >{{ text }}</p>
          </label>
        </div>
        <div>
          <the-select
            class="employee-add__form__multiline"
            title="Выберите роль"
            v-bind:options="employeeRoleList"
            v-bind:value="roleId"
            v-bind:violations="roleIdInputErrors"
            v-on:input="onInputRole"
          />
        </div>
        <label
          class="employee-add__form__group"
          v-if="!isAdmin && !isAssistant"
        >
          <span class="employee-add__form__label">Укажите специализацию</span>
          <input
            class="employee-add__form__input"
            placeholder=""
            type="text"
            v-model="specialtyName"
            v-letter-capital />
          <p
            class="employee-add__form__error-text"
            role="alert"
            v-bind:key="id"
            v-for="(text, id) in specialityNameInputErrors"
          >{{ text }}</p>
        </label>
        <div
          class="employee-add__form__contacts"
          v-bind:class="{ align: phoneNumberInputErrors.length > 0 }">
          <input-phone
            v-bind:required="false"
            v-bind:violations="phoneNumberInputErrors"
            v-model="phoneNumber" />
          <div class="employee-add__form__contact__row">
            <label class="employee-add__form__contact whats-app">
              <input
                type="checkbox"
                v-model="hasWhatsappByPhone" />
              <span>WhatsApp</span>
            </label>
            <label class="employee-add__form__contact telegram">
              <input
                type="checkbox"
                v-model="hasTelegramByPhone" />
              <span>Telegram</span>
            </label>
          </div>
        </div>
        <template>
          <h2>Дополнительно</h2>
          <div class="employee-add__form__extra">
            <div class="employee-add__form__extra__row">
              <input-date
                label="Дата рождения"
                v-bind:violations="birthDateInputErrors"
                v-model="birthDate" />
              <input-inn
                v-bind:violations="innInputErrors"
                v-bind:optional="true"
                v-model="inn"
              />
              <input-snils
                v-bind:optional="!hasEgisz"
                v-bind:violations="snilsInputErrors"
                v-model="snils"
              />
            </div>
            <div class="employee-add__form__checkboxes">
              <template v-if="!isDismissed">
                <input-checkbox
                  v-if="!isAdmin && !isAssistant"
                  title="Выводить в расписании"
                  v-model="isEnabledWorkingScheduling" />

                <input-checkbox
                  v-if="!isAdmin && !isAssistant && isEnabledWorkingScheduling"
                  title="Запретить ставить сотрудника в другие кабинеты в расписании"
                  v-model="isForbidSelectOtherCabinetsInSchedule" />
              </template>
            </div>
            <div v-if="isEnabledWorkingScheduling" class="employee-add__form__extra">
              <div
                v-if="!isAdmin && !isAssistant"
              >
                <multiline-select
                  v-bind:items="cabinetList"
                  v-bind:label="'Выберите кресло'"
                  v-bind:hint="'Кресло по умолчанию нужно для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кресла'"
                  v-model="cabinetIds"
                  class="employee-add__form__extra__multiline" />
                <p
                  class="employee-add__form__error-text"
                  role="alert"
                  v-bind:key="id"
                  v-for="(text, id) in cabinetInputErrors"
                >{{ text }}</p>
              </div>
              <div
                v-if="!isAdmin && !isAssistant"
                class="employee-add__form__extra__steps">
                Шаг приёма:
                <div class="employee-add__form__extra__tags">
                  <label
                    v-for="(option, index) in timeStepList"
                    v-bind:key="index"
                    class="employee-add__form__extra__tag"
                    v-bind:class="{ active: option.value === defaultTimeStepMinutes }"
                  >
                    <input
                      type="radio"
                      v-model="defaultTimeStepMinutes"
                      v-bind:value="option.value"
                    />
                    <span>{{ option.title }}</span>
                  </label>
                </div>
              </div>
              <div class="employee-add__form__description">
                <label
                  class="employee-add__form__group"
                  v-bind:class="{ field_error: infoInputErrors.length > 0 }"
                >
                  <textarea
                    class="employee-add__form__textarea"
                    placeholder="Информация о сотруднике"
                    v-model="info"
                    maxlength="100"
                    rows="4"
                    v-letter-capital
                  />
                  <p
                    class="employee-add__form__error-text"
                    role="alert"
                    v-bind:key="id"
                    v-for="(text, id) in infoInputErrors"
                  >{{ text }}
                  </p>
                </label>
              </div>
            </div>
            <div class="employee-add__form__checkboxes">
              <template v-if="!isDismissed">
                <input-checkbox
                  title="Разрешить доступ к системе"
                  v-model="isAllowedLogin" />
              </template>
            </div>
            <template v-if="isAllowedLogin && !isDismissed">
              <div class="employee-add__form__single">
                <label
                  class="employee-add__form__group"
                  v-bind:class="{ field_error: emailAddressInputErrors.length > 0 }"
                >
                  <span class="employee-add__form__label">E-mail</span>
                  <input
                    autocomplete="off"
                    class="employee-add__form__input"
                    placeholder=""
                    type="email"
                    v-model="emailAddress" />
                  <p
                    class="employee-add__form__error-text"
                    role="alert"
                    v-bind:key="id"
                    v-for="(text, id) in emailAddressInputErrors"
                  >{{ text }}</p>
                </label>
              </div>
            </template>
          </div>
        </template>
        <template>
          <h2>Права</h2>
          <v-expansion-panels
            multiple
            style="flex-direction: column"
          >
            <div class="employee-add__form__permission">
              <template v-for="(group, key) in permissions">
                <div
                  v-bind:key="key"
                  v-if="group.withoutGroup"
                >
                  <permission-item
                    v-for="permission in group.permissions"
                    v-bind:key="`${permission.id}-${permission.value}`"
                    v-bind:is-contains="permission.isContains"
                    v-bind:name="permission.name"
                    v-model="permission.value" />
                </div>
                <v-expansion-panel
                  v-bind:key="key"
                  v-else
                >
                  <v-expansion-panel-header>
                    <div class="employee-add__form__permission__caption">{{group.name}}</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="employee-add__form__permission__row">
                      <permission-item
                        v-for="permission in group.permissions"
                        v-bind:key="`${permission.id}-${permission.value}`"
                        v-bind:is-contains="permission.isContains"
                        v-bind:name="permission.name"
                        v-model="permission.value" />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </div>
          </v-expansion-panels>
        </template>
        <div
          class="employee-add__form__collapse not-indent"
          v-if="allowedEgisz"
        >
          <h2>ЕГИСЗ</h2>
          <autocomplete-input
            attach
            item-text="title"
            item-value="value"
            label="Должность"
            v-bind:error-messages="nsiPositionInputErrors"
            v-bind:items="nsiPositionList"
            v-model="nsiPositionId"
          />
          <autocomplete-input
            attach
            class="employee-add__form__specialty"
            item-text="title"
            item-value="value"
            label="Специальность"
            v-bind:error-messages="specialtyInputErrors"
            v-bind:items="employeeSpecialtyList"
            v-model="specialtyId"
          />
          <the-select
            title="Выберите уровень конфиденциальности"
            v-bind:optional="true"
            v-bind:options="confidentialityLevels"
            v-bind:violations="confidentialityLevelErrors"
            v-model="confidentialityLevelId"
          />
        </div>
        <button
          class="employee-add__form__button-save"
          type="submit"
          v-bind:disabled="isAwaitRequest"
        >
          Создать
        </button>
      </form>
    </div>
  </main>
</template>

<script>
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputDate from '@/components/InputDate.vue';
import InputInn from '@/components/InputInn.vue';
import InputPhone from '@/components/InputPhone.vue';
import MultilineSelect from '@/components/MultilineSelect.vue';
import formMeaningfulFieldsMixin from '@/mixins/formMeaningfulFieldsMixin';
import { EmployeeCreationRequest } from '@/storage/gateways/EmployeeGateway';
import dateMixin, { getISODateStringByDate } from '@/mixins/dateMixin';
import PermissionItem from '@/components/PermissionItem.vue';
import TheSelect from '@/components/TheSelect.vue';
import notifierMixin from '@/mixins/notifierMixin';
import InputSnils from '@/components/InputSnils.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Страница создания сотрудника.
 * @type {Vue}
 */
export default {
  components: {
    InputSnils,
    TheSelect,
    PermissionItem,
    MultilineSelect,
    InputCheckbox,
    InputDate,
    InputInn,
    InputPhone,
    AutocompleteInput,
  },
  tooltipText: 'Кабинет по умолчанию нужен для удобства заполнения расписания. В графике работы вы можете в любой день указывать сотруднику другие кабинеты.',
  computed: {
    allowedEgisz() {
      return this.hasEgisz && (
        this.isAdmin !== true && this.isAssistant !== true && /^\d+$/.test(this.roleId) !== true
      );
    },
    birthDateISO: ({ birthDate, formatDateToISO }) => formatDateToISO(birthDate),
    /**
     * @description Дата увольнения сотрудника.
     * @type {string}
     */
    dismissedDateText() {
      if (this.dismissedDate) {
        return this.getFullDate(this.dismissedDate);
      }
      return 'Укажите дату';
    },
    /**
     * @description Является ли сотрудник администратором.
     * @return {boolean}
     */
    isAdmin() {
      return this.roleId === 'admin';
    },
    /**
      * @description Является ли сотрудник ассистентом.
      * @return {boolean}
      */
    isAssistant() {
      return this.roleId === 'assistant';
    },
    birthDateInputErrors: resolveInputErrors('birth-date'),
    cabinetInputErrors: resolveInputErrors('cabinet-id'),
    confidentialityLevelErrors: resolveInputErrors('confidentiality-level'),
    dismissedDateInputErrors: resolveInputErrors('dismissed-date'),
    emailAddressInputErrors: resolveInputErrors('email'),
    roleIdInputErrors: resolveInputErrors('employee-role'),
    infoInputErrors: resolveInputErrors('info'),
    innInputErrors: resolveInputErrors('inn'),
    nameInputErrors: resolveInputErrors('name'),
    nsiPositionInputErrors: resolveInputErrors('nsi-position'),
    patronymicInputErrors: resolveInputErrors('patronymic'),
    phoneNumberInputErrors: resolveInputErrors('phone'),
    snilsInputErrors: resolveInputErrors('snils'),
    specialtyInputErrors: resolveInputErrors('specialty-id'),
    surnameInputErrors: resolveInputErrors('surname'),
    specialityNameInputErrors: resolveInputErrors('speciality-name'),
  },
  created() {
    this.fetchEmployeeProfileOptions();
  },
  data() {
    return {
      cabinetList: [],
      confidentialityLevels: [],
      employeeRoleList: [],
      employeeSpecialtyList: [],
      nsiPositionList: [],
      permissionsByGroups: [],
      timeStepList: [],
      birthDate: '',
      cabinetIds: [],
      confidentialityLevelId: '',
      defaultTimeStepMinutes: 30,
      dismissedDate: '',
      emailAddress: '',
      hasEgisz: false,
      hasTelegramByPhone: false,
      hasUser: false,
      hasWhatsappByPhone: false,
      info: '',
      inn: '',
      isAllowedCashbox: false,
      isAllowedLogin: false,
      isDismissed: false,
      isEnabledWorkingScheduling: true,
      isForbidSelectOtherCabinetsInSchedule: false,
      isSendCredentialsMessage: false,
      name: '',
      nsiPositionId: '',
      patronymic: '',
      permissions: [],
      phoneNumber: '',
      roleId: '',
      snils: '',
      specialtyId: null,
      specialtyName: '',
      surname: '',
      isAwaitRequest: false,
      inputErrors: {},
    };
  },
  currentDate: getISODateStringByDate(new Date()),
  methods: {
    /**
     * @description Получит данные для профиля сотрудника.
     * @returns {any}
     */
    fetchEmployeeProfileOptions() {
      const onResponse = (result) => {
        this.cabinetList = result
          .cabinetList
          .map(({ name: title, id: value }) => ({ title, value }));
        this.confidentialityLevels = result
          .confidentialityLevels
          .map(({ name: title, id: value }) => ({ title, value }));
        this.employeeRoleList = result
          .employeeRoleList
          .map(({ name: title, id: value, default_permissions: defaultPermissions }) => (
            { title, value, defaultPermissions }
          ));
        this.employeeSpecialtyList = result
          .employeeSpecialtyList
          .map(({ name: title, id: value }) => ({ title, value }));
        this.hasEgisz = result.hasEgisz;
        this.nsiPositionList = result
          .nsiPositionList
          .map(({ name: title, id: value }) => ({ title, value }));
        this.permissionsByGroups = result.permissionsByGroups;
        this.timeStepList = result
          .timeStepList
          .map(({ title, number_minutes: value }) => ({ title, value }));
        this.fetchInitialPermissions();
        this.onInputRole('admin');
      };
      this.$suggestionGateway.getEmployeeCreation().then(onResponse);
    },
    fetchInitialPermissions() {
      this.permissions = this
        .permissionsByGroups.map((group) => {
          const permissions = group.permissions.map(({ id, name }) => ({
            id,
            isContains: false,
            name,
            value: 'by-positions',
          }));
          return ({
            name: group.name,
            permissions,
            withoutGroup: false,
          });
        });
    },
    /**
     * @description Функция описывающая условие доступности выбора дат в datepicker
     * @param {string} candidate Строка с датой в формате Y-m-d
     * @return {boolean}
     */
    allowedDates(candidate) {
      return candidate <= this.$options.currentDate;
    },
    /**
     * @description Создать запрос на создание сотрудника.
     * @returns {EmployeeCreationRequest}
     */
    makeEmployeeCreationRequest() {
      const [additionalPermissions, excludedPermissions] = this
        .permissions
        .flatMap(({ permissions }) => permissions)
        .reduce(
          ([additionalAcc, excludedAcc], { id, value }) => [
            [...additionalAcc, ...(value === 'additional' ? [id] : [])],
            [...excludedAcc, ...(value === 'excluded' ? [id] : [])],
          ],
          [[], []],
        );
      return new EmployeeCreationRequest(
        additionalPermissions,
        this.birthDateISO,
        this.cabinetIds,
        this.confidentialityLevelId,
        this.dismissedDate,
        this.emailAddress,
        excludedPermissions,
        this.roleId,
        this.hasTelegramByPhone,
        this.hasWhatsappByPhone,
        this.info,
        this.inn,
        this.isAllowedCashbox,
        this.isAllowedLogin,
        this.isDismissed,
        this.isEnabledWorkingScheduling,
        this.isForbidSelectOtherCabinetsInSchedule,
        this.name,
        this.hasEgisz,
        this.nsiPositionId,
        this.isSendCredentialsMessage,
        this.patronymic,
        this.phoneNumber,
        this.snils.replace(/[-\s]/g, ''),
        this.specialtyId,
        this.specialtyName,
        this.surname,
        this.defaultTimeStepMinutes,
      );
    },
    /**
     * @description Обработать изменение роли.
     * @type {string} roleId Идентификатор роли.
     * @returns {void}
     */
    onInputRole(roleId) {
      this.roleId = roleId;
      const { defaultPermissions } = this
        .employeeRoleList
        .find((candidate) => candidate.value === roleId);
      const mapPosition = (candidate) => ({
        ...candidate,
        value: 'by-positions',
        isContains: defaultPermissions.includes(candidate.id),
      });
      this.permissions = this
        .permissions
        .map((group) => ({ ...group, permissions: group.permissions.map(mapPosition) }));
    },
    /**
     * @description Обработать сохранение сотрудника.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeEmployeeCreationRequest();
      const onError = (response) => {
        this.$refs.body.scrollIntoView({ behavior: 'smooth' });
        this.inputErrors = response.allCauses();
      };
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.$router.push({ name: 'ClinicPanelEmployeeList' });
        this.inputErrors = {};
      };
      this.isAwaitRequest = true;
      this.$employeeGateway
        .create(request)
        .then((result) => result.fold(onError, onSuccess))
        .finally(() => {
          this.isAwaitRequest = false;
        });
    },
  },
  mixins: [
    dateMixin,
    formMeaningfulFieldsMixin,
    notifierMixin,
  ],
  name: 'ClinicPanelFormEmployee',
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.employee-add {
  width: 100%;
  overflow-y: scroll;
  &__body {
    width: 100%;
    max-width: 1187px;
    padding: 38px 20px 48px 23px;
  }
  &__form {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 34px;
    margin: 47px 0 0 0;
    background: #f2f5f8;
    padding: 20px;
    &__button-save {
      @include buttons.btn-blue(100%, 56px, 20px);
      max-width: 174px;
    }
    &__date {
      &__label {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: #90A0B7;
        margin: 0 0 3px 0;
      }
      &__activator {
        padding: 10px 50px 10px 10px;
        border: 1px solid #C2CFE0;
        background-color: white;
        border-radius: 4px;
        font-size: 16px;
        background-image: url("@/assets/img/calendar-grey.svg");
        background-position: right 10px center;
      }
    }
    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 10px;
    }
    &__group {
      display: flex;
      flex-direction: column;
      &.field_error {
        .employee-creation__label {
          color: var(--warning-color);
        }
      }
    }
    &__label {
      color: #90A0B7;
      opacity: 0.7;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
    }
    &__multiline {
      flex: 1;
      &.explanation {
        .multiline-select__row:first-child {
          .multiline-select__placeholder {
            cursor: pointer !important;
            pointer-events: auto;
            &:after {
              content: "?";
              font-size: 13px;
              margin: 0 0 0 5px;
            }
          }
        }
      }
    }
    &__input {
      background: #ffffff;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      outline: none;
      height: 40px;
      width: 100%;
      padding: 0 10px;
      appearance: none;
      font-size: 16px;
      color: #192a3e;
      font-weight: 400;
      &:focus {
        color: #192a3e;
        background-color: #fff;
        border: 2px solid #0489e0;
        outline: 0;
      }
      &:disabled {
        background-color: #fff;
      }
    }
    &__error-text {
      color: var(--warning-color);
      font-size: 12px;
      line-height: 12px;
      padding: 0;
      margin: 5px 0 0 0;
      background-color: transparent!important;
    }
    &__extra {
      display: flex;
      flex-direction: column;
      position: relative;
      gap: 34px;
      max-width: 737px;
      &__row {
        display: grid;
        grid-template-columns: 130px 1fr 1fr;
        grid-gap: 35px;
      }
      &__multiline {
        grid-gap: 40px !important;
        .multiline-select__row {
          grid-template-columns: 737px 100px;
        }
      }
      &__steps {
        display: flex;
        flex-flow: row wrap;
        align-items: baseline;
        gap: 20px;
        font-size: 16px;
        font-weight: 600;
        color: #192A3E;
      }
      &__tags {
        display: flex;
        flex-flow: row wrap;
        gap: 2px;
      }
      &__tag {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #EAEFF3;
        color: #192A3E;
        padding: 8px 16px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        &:first-child {
          border-radius: 4px 0 0 4px;
        }
        &:last-child {
          border-radius: 0 4px 4px 0;
        }
        &.active,
        &:hover {
          background-color: #0489E0;
          color: #FFFFFF;
        }
        input {
          position: absolute;
          z-index: -1;
          opacity: 0;
        }
      }
    }
    &__contacts {
      display: grid;
      grid-template-columns: 0.97fr 2fr;
      align-items: flex-start;
      grid-gap: 10px;
    }
    &__contact {
      display: flex;
      align-items: center;
      background-color: #eef2f8;
      border-radius: 4px;
      padding: 8px;
      cursor: pointer;
      &> input {
        position: absolute;
        z-index: -1;
        opacity: 0;
        &:not(:disabled):not(:checked) + span:hover::after {
          border-color: #0489e0;
        }
        &:checked:focus + span::after {
          border-color: var(--focus-input-color) !important;
        }
        &:not(:disabled):active + span::after {
          background-color: #90a0b7;
          border-color: #90a0b7;
        }
        &:focus:not(:checked) + span::after {
          border-color: #0489e0;
        }
        &:checked + span::after {
          background-color: #0489e0;
          border-color: #0489e0;
          background-image: url("@/assets/img/checked/checked-white-top.svg");
        }
      }
      &> span {
        display: inline-flex;
        align-items: center;
        user-select: none;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        outline: none;
        &::after {
          content: "";
          display: inline-block;
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          flex-grow: 0;
          border: 1px solid #90a0b7;
          border-radius: 4px;
          margin: 0 0 0 10px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 70%;
          background-color: #ffffff;
        }
      }
      &__row {
        display: flex;
        flex-direction: row;
        position: relative;
        margin: 17.5px 0 0 0;
      }
      &.whats-app {
        margin: 0 10px 0 0;
      }
      &:before {
        content: "";
        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-size: contain;
        margin: 0 10px 0 0;
      }
      &.whats-app:before {
        background-image: url("@/assets/img/social/whats-app-grey.svg");
      }
      &.telegram:before {
        background-image: url("@/assets/img/social/telegram-grey.svg");
      }
      &__text {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        background-color: white;
        color: rgba(0,0,0,.87);
        padding: 5px;
        border-radius: 5px;
        box-shadow: 0 0 20px rgba(54, 77, 92, 0.18);
        max-width: 250px;
        font-size: 12px;
      }
      &__indent {
        margin: 15px 0 0 0;
        .multiline-select {
          grid-gap: 33px;
        }
      }
    }
    &__cabinet,
    &__step {
      display: grid;
      align-items: center;
      &__label {
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #192a3e;
        margin: 0 23px 0 0;
      }
      &__input {
        background-color: #ffffff;
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-position: right 17px center;
        border: 1px solid #c2cfe0;
        border-radius: 4px;
        outline: none;
        height: 40px;
        padding: 0 10px;
        appearance: none;
        font-size: 16px;
        color: #192a3e;
        font-weight: 400;
        &.validate {
          border-color: var(--warning-color);
        }
        &:focus {
          color: #192a3e;
          background-color: #fff;
          border: 2px solid #0489e0;
          outline: 0;
          background-image: url("@/assets/img/checked/checked-grey-top.svg");
        }
        &:disabled {
          background-color: #fff;
          background-image: url("@/assets/img/checked/checked-grey.svg");
        }
      }
    }
    &__cabinet {
      grid-template-columns: 10rem 1fr;
      width: 70%;
    }
    &__step {
      grid-template-columns: 120px 1fr;
      width: 45%;
    }
    &__textarea {
      background: #ffffff;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      z-index: 2;
      outline: none;
      -webkit-appearance: none;
      width: 100%;
      padding: 10px;
      appearance: none;
      font-size: 16px;
      color: #626262;
      font-weight: 400;
      &:focus {
        background-color: #fff;
        padding: 9px;
        border: 2px solid #0489e0;
      }
    }
    &__description {
      width: 100%;
    }
    &__checkboxes {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 10px;
    }
    &__single {
      width: 45%;
    }
    &__password {
      position: relative;
      & > .employee-creation__input {
        padding-right: 40px;
      }
      &__toggle {
        background-image: url("@/assets/img/eye-closed.svg");
        background-position: center;
        height: 40px;
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        &.active {
          background-image: url("@/assets/img/eye-open.svg");
        }
        cursor: pointer;
      }
    }
    &__specialty {
      & .v-list-item__title {
        white-space: normal;
      }
    }
    &__collapse {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 0;
      &.indent {
        margin: 20px 0 0 0;
      }
      .v-expansion-panel:first-child {
        margin: 20px 0 0 0;
      }
      .v-expansion-panel:before {
        box-shadow: none;
      }
      .v-expansion-panel-header {
        padding: 0;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #192a3e;
        min-height: 25px;
      }
      .v-expansion-panel:not(:first-child):after {
        border-top: none;
      }
      .v-expansion-panel-content__wrap {
        padding: 0;
      }
      .v-expansion-panel-content {
        margin: 15px 0 0 0;
      }
    }
    &__permission {
      &__caption {
        font-size: 18px;
      }
      &__row {
        display: flex;
        flex-flow: row wrap;
        gap: 10px 20px;
      }
    }
  }
}
@media screen and (max-width: 1064px) {
  .employee-add {
    &__form {
      &__extra {
        &__multiline {
          .multiline-select__row {
            grid-template-columns: 1fr 100px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 920px) {
  .employee-add__form {
    &__single {
      width: 60%;
    }
    &__step {
      width: 60%;
    }
  }
}
@media screen and (max-width: 700px) {
  .employee-add {
    &__form {
      &__extra {
        &__row {
          grid-template-columns: 1fr;
          grid-gap: 34px;
        }
      }
    }
  }
}
@media screen and (max-width: 520px) {
  .employee-add__form {
    &__row {
      grid-template-columns: 1fr;
    }
    &__single {
      width: 100%;
    }
    &__step {
      width: 100%;
    }
    &__contacts {
      grid-template-columns: 1fr;
      &.align {
        align-items: center;
        .employee-creation__contact__row {
          margin: 0 0 0 0;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .employee-add__form {
    background: transparent;
    padding: 0;
    &__contact {
      width: max-content;
      &.whats-app {
        margin: 0 0 10px 0;
      }
      &__row {
        flex-direction: column;
      }
    }
    &__date__activator {
      width: 100%;
      text-align: left;
    }
  }
}
</style>
